import { render, staticRenderFns } from "./incidents.vue?vue&type=template&id=0bee7c1a&"
import script from "./incidents.vue?vue&type=script&lang=js&"
export * from "./incidents.vue?vue&type=script&lang=js&"
import style0 from "./incidents.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports